<template>
  <div class="kakao-callback-container">
    <div class="loading-box">
      <div class="spinner"></div>
      <p class="loading-text">카카오 로그인 처리 중입니다...</p>
      <p class="sub-text">잠시만 기다려주세요.</p>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import { mapActions } from 'vuex';

export default {
  name: 'KakaoCallback',
  mounted() {
    const code = this.$route.query.code;
    if (code) {
      this.handleKakaoLogin(code);
    } else {
      this.$message.error('카카오 로그인에 실패하였습니다. (인증 코드가 없습니다)');
      this.$router.replace('/login');
    }
  },
  methods: {
    ...mapActions(['login']),
    handleKakaoLogin(code) {
      const redirectUri = window.location.origin + "/kakao-callback";
      request.post('/User/kakaoLogin', { code: code, redirect_uri: redirectUri })
        .then(response => {
          if (response.code === 1) {
            const userinfo = response.data.userinfo;
            
            // 登录 Vuex 会话保存
            this.login({
              token: userinfo.token,
              nickname: userinfo.nickname,
              user_id: userinfo.id
            });

            this.$message.success('로그인 성공!');
            
            // 检查是否有重定向来源页，有则跳回来源页，否则回首页
            const redirectPath = localStorage.getItem('redirectPath');
            if (redirectPath) {
              localStorage.removeItem('redirectPath');
              this.$router.replace(redirectPath);
            } else {
              this.$router.replace('/');
            }
          } else {
            this.$message.error(response.msg || '로그인 처리에 실패했습니다.');
            this.$router.replace('/login');
          }
        })
        .catch(err => {
          console.error('Kakao login error:', err);
          this.$message.error('서버 통신 오류가 발생했습니다.');
          this.$router.replace('/login');
        });
    }
  }
}
</script>

<style scoped>
.kakao-callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.loading-box {
  text-align: center;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #FEE500; /* Kakao Yellow */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.loading-text {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.sub-text {
  font-size: 14px;
  color: #888;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
